export default __webpack_public_path__ + "undo-arrow.png";